import {
  Typography,
  Card,
  CardContent,
  Stack,
  Chip,
  Avatar,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

export default function DashboardClientesFrecuentes({ store }) {
  const clientes = store.clientesFrecuentes;

  if (!clientes || clientes.length === 0) return null;

  return (
    <Card variant="outlined" sx={{ mt: 3 }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" mb={2}>
          <StarIcon sx={{ color: "favorite.main" }} />
          <Typography variant="subtitle1">Clientes frecuentes</Typography>
          <Chip label={`${clientes.length} VIP`} size="small" color="warning" sx={{ fontWeight: 700 }} />
        </Stack>
        <Stack spacing={1}>
          {clientes.slice(0, 8).map((c, i) => (
            <Stack key={c.nombre + i} direction="row" justifyContent="space-between" alignItems="center"
              sx={{ p: 1, borderRadius: 1, bgcolor: i < 3 ? "tint.warning" : "transparent" }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar sx={{ width: 28, height: 28, fontSize: 13, bgcolor: i < 3 ? "favorite.main" : "grey.500" }}>
                  {c.nombre?.charAt(0)?.toUpperCase() || "?"}
                </Avatar>
                <Typography variant="body2" fontWeight={600}>{c.nombre}</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Chip label={`${c.compras} compras`} size="small" variant="outlined" sx={{ fontWeight: 700 }} />
                <Typography variant="body2" fontWeight={700} color="success.main">
                  LTV · {store.config.moneda} {c.total.toLocaleString()}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
